import {BaseService} from "./BaseService";
import {BaseApiClient, BearerApiClient} from "./APIClient";
import {useAuth} from "../hooks/useAuth";
import {UserPermissions} from "../models/UserPermissions";


export class AuthService extends BaseService {

    private async obtainToken(email: string, password: string) {
        const client = BaseApiClient();

        return this.response<{token: string}>(
            client.post(this.BASE_URL + "/auth/login",{
                email,
                password,
            })
        );
    }

    public async getUser(token: string) {
        const client = BearerApiClient(token);

        return this.response(
            client.get(this.BASE_URL + "/auth/user")
        )
    }

    public async getPermissions() {
        const client = BearerApiClient();

        return this.response<UserPermissions>(
            client.get(this.BASE_URL + "/auth/permissions")
        )
    }


    public async login(email: string, password: string) {
        try {
            const response = await this.obtainToken(email, password);
            useAuth.getState().setToken(response.token);
            return response
        } catch (e) {
            throw e;
        }
    }

    public async passwordReset(email: string) {
        const client = BaseApiClient();
        return this.response<any>(
            client.post(this.BASE_URL + "/auth/password-reset", {
                email
            })
        );
    }

    public async setNewPassword(payload: {
        email: string,
        password: string,
        password_confirmation: string,
        token: string
    }) {
        const client = BaseApiClient();
        return this.response<any>(
            client.post(this.BASE_URL + "/auth/password-reset/password", payload)
        );
    }

}